/*
 * Шаги курса «Постановка звуков у ребёнка» (speech-sounds-course).
 *
 *   airflow       — длительность и ровность выдоха («ветерок», «насос»):
 *                   микрофон слышит поток воздуха; без микрофона — секундомер
 *                   (честно подписан «по секундомеру»).
 *   sound-target  — «живая мишень»: пик шума свистящего/шипящего на шкале
 *                   2–9 кГц против зоны звука (SpeechSoundMeter.frame —
 *                   тот же измеритель, что у тренажёра /speech-sounds).
 *                   Прибор видит ТОЛЬКО положение пика: «с» против «ш».
 *                   Межзубное и боковое произношение, Л и Р он не оценивает —
 *                   замер и границы в docs/why/speech-sounds-course.md.
 *   phoneme-game  — игры на слух, которые ведёт взрослый: страница
 *                   подсказывает взрослому слово, ребёнок отвечает картинкой
 *                   или кнопкой. Голос — взрослого, а не синтезатора: так
 *                   играют по методике, и это работает на любом устройстве.
 *
 * Записи нет: прибор разбирает последние 46 мс звука прямо в странице.
 * Микрофон — только через MusicCore.listen → api.mic (дверь __tmbGum).
 */
(function () {
    'use strict';
    var K = window.CourseKit;
    if (!K) return;

    function T(step) { return step.t || {}; }
    function M() { return window.SpeechSoundMeter || null; }
    function dec1(x) {
        try { return new Intl.NumberFormat(window.__intlLocale ? window.__intlLocale() : 'ru', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(x); }
        catch (_) { return (Math.round(x * 10) / 10).toFixed(1); }
    }
    /* Запись из цикла кадров — через примитивы ядра: пишут только когда
       пиксель или текст действительно изменился (PlayheadWritesGoThroughThePrimitiveTest). */
    function pxWrite(e, p, v, u) { if (window.__perPixel) return window.__perPixel(e, p, v, u); e.style[p] = v + (u || '%'); }
    function textWrite(e, t) { if (window.__setText) return window.__setText(e, t); e.textContent = t; }
    function rmsOf(pcm) {
        var s = 0;
        for (var i = 0; i < pcm.length; i++) s += pcm[i] * pcm[i];
        return Math.sqrt(s / Math.max(1, pcm.length));
    }
    function lines(host, api, list, cls) {
        if (!list || !list.length) return;
        var ul = api.el('ul', cls || 'ssc-how');
        list.forEach(function (s) { ul.appendChild(api.richEl('li', null, s)); });
        host.appendChild(ul);
    }

    /* ── микрофон: одна панель на все шаги ─────────────────────────── */
    function micPanel(host, api, onReady, alt) {
        var box = api.el('div', 'ssc-mic');
        var meter = api.el('div', 'ssc-meter');
        var bar = api.el('span');
        meter.appendChild(bar);
        var status = api.el('p', 'ssc-status');
        status.setAttribute('aria-live', 'polite');
        status.textContent = api.tt('ss_mic_hint');
        box.appendChild(meter);
        box.appendChild(status);
        host.appendChild(box);
        var raf = 0, L = null;
        function loop() {
            if (!api.alive() || !L) return;
            var db = 20 * Math.log10(L.level() + 1e-9);
            pxWrite(bar, 'width', Math.max(0, Math.min(100, (db + 60) / 50 * 100)));
            raf = requestAnimationFrame(loop);
        }
        api.onCleanup(function () { if (raf) cancelAnimationFrame(raf); });
        function start() {
            if (!window.MusicCore || !M()) { status.textContent = api.tt('ss_mic_unavailable'); noMic(); return; }
            api.primary(api.tt('ss_mic_start'), null, true);
            status.textContent = api.tt('ss_mic_wait');
            window.MusicCore.listen(api).then(function (listener) {
                if (!api.alive()) { listener.stop(); return; }
                L = listener;
                box.classList.add('is-on');
                status.textContent = api.tt('ss_mic_on');
                raf = requestAnimationFrame(loop);
                api.secondary(null, null);
                onReady(listener, status);
            }, function (err) {
                if (!api.alive()) return;
                status.textContent = api.micError(err);
                box.classList.add('is-off');
                api.primary(api.tt('ss_mic_retry'), start);
                noMic();
            });
        }
        function noMic() {
            if (alt) api.secondary(alt.label, alt.fn);
            else api.secondary(api.tt('ss_no_mic_skip'), function () { api.skip(api.tt('ss_skipped')); });
        }
        api.primary(api.tt('ss_mic_start'), start);
        if (alt) api.secondary(alt.label, alt.fn);
        else api.secondary(api.tt('ss_no_mic_skip'), function () { api.skip(api.tt('ss_skipped')); });
        return status;
    }

    /* ════ airflow ════
       data: seconds (цель выдоха), mode 'blow' (воздух без голоса) | 'hiss'
       (протяжный «с-с-с»: считаются только кадры шума звука). */
    var BREATH_MARGIN_DB = 10;   /* громче тишины комнаты на 10 дБ — это выдох */
    var BREATH_GAP_MS = 250;     /* провал короче — тот же выдох */
    var BREATH_END_MS = 700;     /* тишина дольше — выдох кончился */

    K.step('airflow', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var want = step.seconds || 3;
            var hiss = step.mode === 'hiss';
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host);
            lines(host, api, t.how);
            var big = api.el('p', 'ssc-big', dec1(0));
            host.appendChild(big);
            var goal = api.el('div', 'ssc-goal');
            var gbar = api.el('span');
            goal.appendChild(gbar);
            host.appendChild(goal);
            host.appendChild(api.el('p', 'crs-hint', api.tt('ss_goal_line', { s: dec1(want) })));
            var done = false;
            var status = micPanel(host, api, function (L, st) {
                st.textContent = api.tt('ss_breath_quiet');
                var calib = [], floor = null, start = null, last = null, best = 0, db = [], bestDb = [], t0 = null;
                var unsub = L.onBlock(function (pcm, frame) {
                    if (done) return;
                    var tMs = (frame + pcm.length) / L.sr * 1000;
                    var r = rmsOf(pcm);
                    if (t0 == null) t0 = tMs;
                    if (floor == null) {
                        calib.push(r);
                        if (tMs - t0 > 1200) {
                            calib.sort(function (a, b) { return a - b; });
                            var fl = calib[calib.length >> 1];
                            if (fl > 0.01) { calib = []; t0 = tMs; st.textContent = api.tt('ss_breath_noisy'); return; }
                            floor = Math.max(0.0015, fl * Math.pow(10, BREATH_MARGIN_DB / 20));
                            st.textContent = api.tt(hiss ? 'ss_hiss_go' : 'ss_blow_go');
                            api.primary(api.tt('ss_done'), function () { finish(best / 1000, stability(bestDb), false); });
                        }
                        return;
                    }
                    var on = r >= floor;
                    if (on && hiss) {
                        var f = M().frame(L.latest(Math.round(L.sr * 0.046)), L.sr);
                        on = !!(f && f.fricative);
                    }
                    if (on) {
                        if (start == null || tMs - last > BREATH_GAP_MS) { start = tMs; db = []; }
                        last = tMs;
                        db.push(20 * Math.log10(r));
                        if (tMs - start > best) { best = tMs - start; bestDb = db.slice(); }
                    }
                    var active = start != null && tMs - last <= BREATH_GAP_MS;
                    var shown = active ? (last - start) / 1000 : 0;
                    textWrite(big, dec1(shown));
                    pxWrite(gbar, 'width', Math.min(100, shown / want * 100));
                    if (start != null && tMs - last > BREATH_END_MS && best >= 800) finish(best / 1000, stability(bestDb), false);
                });
                api.onCleanup(unsub);
            }, { label: api.tt('ss_stopwatch'), fn: stopwatch });
            function stability(d) {
                if (!d || d.length < 20) return null;
                var mid = d.slice(Math.floor(d.length * 0.15), Math.ceil(d.length * 0.85));
                var m = mid.reduce(function (a, b) { return a + b; }, 0) / mid.length;
                return Math.sqrt(mid.reduce(function (a, v) { return a + (v - m) * (v - m); }, 0) / mid.length);
            }
            function stopwatch() {
                var t0 = 0, iv = 0;
                status.textContent = api.tt('ss_sw_hint');
                api.onCleanup(function () { clearInterval(iv); });
                api.secondary(null, null);
                api.primary(api.tt('ss_sw_start'), function () {
                    t0 = performance.now();
                    iv = setInterval(function () {
                        var s = (performance.now() - t0) / 1000;
                        textWrite(big, dec1(s));
                        pxWrite(gbar, 'width', Math.min(100, s / want * 100));
                    }, 100);
                    api.primary(api.tt('ss_sw_stop'), function () { clearInterval(iv); finish((performance.now() - t0) / 1000, null, true); });
                });
            }
            function finish(sec, stab, manual) {
                if (done) return;
                done = true;
                var out = [api.tt(manual ? 'ss_breath_res_sw' : 'ss_breath_res', { s: dec1(sec), want: dec1(want) })];
                if (sec < want * 0.6) out.push(api.tt('ss_breath_short'));
                if (stab != null) out.push(stab <= 3 ? api.tt('ss_breath_even') : api.tt('ss_breath_uneven'));
                api.answer({ correct: null, explain: out.join('\n') + (t.explain ? '\n\n' + t.explain : '') });
            }
        }
    });

    /* ════ sound-target ════
       data: sound (ключ подписи), lo, hi (зона, Гц), seconds (сколько звучать),
       zones [{lo, hi, key}] — дополнительные зоны на шкале (сравнение с/ш),
       demo — пробует взрослый (без «цели», только где пик). */
    var F_LO = 2000, F_HI = 9000;
    var HUSHING = { sh: 1, zh: 1, ch: 1, shch: 1 };
    function pct(hz) {
        var t = (Math.log(Math.max(F_LO, Math.min(F_HI, hz))) - Math.log(F_LO)) / (Math.log(F_HI) - Math.log(F_LO));
        return t * 100;
    }
    function scale(api, zones) {
        var wrap = api.el('div', 'ssc-scale');
        wrap.setAttribute('aria-hidden', 'true');
        var track = api.el('div', 'ssc-track');
        zones.forEach(function (z) {
            var zb = api.el('div', 'ssc-zone ssc-zone-' + (z.tone || 'a'));
            zb.style.left = pct(z.lo) + '%';
            zb.style.width = Math.max(2, pct(z.hi) - pct(z.lo)) + '%';
            if (z.label) zb.appendChild(api.el('span', 'ssc-zone-l', z.label));
            track.appendChild(zb);
        });
        var dot = api.el('div', 'ssc-dot is-idle');
        track.appendChild(dot);
        wrap.appendChild(track);
        var ticks = api.el('div', 'ssc-ticks');
        [2000, 3000, 4000, 5000, 6000, 8000].forEach(function (f) {
            /* Единица — один раз, у последней метки: на ширине 390 px шесть
               «N кГц» налезали на подписи концов шкалы. */
            var s = api.el('span', null, (f / 1000) + (f === 8000 ? api.tt('ss_khz') : ''));
            s.style.left = pct(f) + '%';
            ticks.appendChild(s);
        });
        wrap.appendChild(ticks);
        var ends = api.el('div', 'ssc-ends');
        ends.appendChild(api.el('span', null, api.tt('ss_scale_low')));
        ends.appendChild(api.el('span', null, api.tt('ss_scale_high')));
        wrap.appendChild(ends);
        return { el: wrap, dot: dot };
    }

    K.step('sound-target', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var want = step.seconds || 3;
            var demo = !!step.demo;
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            api.figure(host);
            lines(host, api, t.how);
            var zones = [];
            if (step.lo && step.hi) zones.push({ lo: step.lo, hi: step.hi, tone: 'a', label: api.tt('ss_snd_' + step.sound) });
            (step.zones || []).forEach(function (z) { zones.push({ lo: z.lo, hi: z.hi, tone: 'b', label: api.tt('ss_snd_' + z.key) }); });
            var sc = scale(api, zones);
            host.appendChild(sc.el);
            var readout = api.el('p', 'ssc-readout', '');
            readout.setAttribute('aria-live', 'polite');
            host.appendChild(readout);
            var hold = api.el('div', 'ssc-goal');
            var hbar = api.el('span');
            hold.appendChild(hbar);
            if (!demo) {
                host.appendChild(hold);
                host.appendChild(api.el('p', 'crs-hint', api.tt('ss_hold_line', { s: dec1(want) })));
            }
            var done = false;
            micPanel(host, api, function (L, st) {
                st.textContent = api.tt(demo ? 'ss_demo_go' : 'ss_target_go');
                var raf = 0, prev = performance.now(), smoothed = null;
                var fric = 0, inZone = 0, below = 0, above = 0, peaks = [];
                api.primary(api.tt('ss_done'), function () { finish(); });
                function tick() {
                    if (!api.alive() || done) return;
                    var now = performance.now(), dt = Math.min(0.1, (now - prev) / 1000);
                    prev = now;
                    var f = M().frame(L.latest(Math.round(L.sr * 0.046)), L.sr);
                    if (f && f.fricative) {
                        smoothed = smoothed === null ? f.peakHz : smoothed * 0.65 + f.peakHz * 0.35;
                        pxWrite(sc.dot, 'left', pct(smoothed));
                        sc.dot.classList.remove('is-idle');
                        var hit = step.lo && smoothed >= step.lo && smoothed <= step.hi;
                        sc.dot.classList.toggle('is-hit', !!hit);
                        fric += dt;
                        if (hit) inZone += dt;
                        else if (step.lo && smoothed < step.lo) below += dt;
                        else if (step.lo) above += dt;
                        peaks.push(smoothed);
                        textWrite(readout, api.tt('ss_peak_now', { hz: Math.round(smoothed / 50) * 50 }));
                        if (!demo) pxWrite(hbar, 'width', Math.min(100, inZone / want * 100));
                        if (!demo && inZone >= want) { finish(); return; }
                    } else {
                        sc.dot.classList.add('is-idle');
                        sc.dot.classList.remove('is-hit');
                        smoothed = null;
                        textWrite(readout, f && f.voiced ? api.tt('ss_voiced_now') : '');
                    }
                    raf = requestAnimationFrame(tick);
                }
                api.onCleanup(function () { if (raf) cancelAnimationFrame(raf); });
                raf = requestAnimationFrame(tick);
                function finish() {
                    if (done) return;
                    done = true;
                    if (raf) cancelAnimationFrame(raf);
                    var out = [];
                    if (fric < 0.8) {
                        out.push(api.tt('ss_res_none'));
                    } else {
                        peaks.sort(function (a, b) { return a - b; });
                        var med = Math.round(peaks[peaks.length >> 1] / 100) * 100;
                        out.push(api.tt('ss_res_peak', { hz: med, s: dec1(fric) }));
                        if (step.lo) {
                            var share = Math.round(inZone / fric * 100);
                            out.push(api.tt('ss_res_share', { p: share, snd: api.tt('ss_snd_' + step.sound) }));
                            if (share >= 60) out.push(api.tt('ss_res_good'));
                            else if (below > above) out.push(api.tt('ss_res_low'));
                            else out.push(api.tt('ss_res_high'));
                            /* На шипящих прибор ошибается заметно чаще: на взрослой речи
                               (FLEURS) пик «ш» уходит в зону «с» примерно в каждом третьем
                               случае — docs/why/speech-sounds-course.md. Ребёнку, который
                               говорит верно, нельзя показать «не попал» как приговор. */
                            if (share < 60 && HUSHING[step.sound]) out.push(api.tt('ss_res_sh_unsure'));
                        }
                        out.push(api.tt('ss_res_limits'));
                    }
                    api.answer({ correct: null, explain: out.join('\n') + (t.explain ? '\n\n' + t.explain : '') });
                }
            }, null);
        }
    });

    /* ════ phoneme-game ════
       Игру ведёт взрослый: страница показывает ЕМУ слово, ребёнок отвечает.
       data.mode:
         pair  — data.pairs [[emojiA, emojiB]], text.pairs [[словоA, словоB]]:
                 взрослый называет одно слово пары, ребёнок нажимает картинку;
         sort  — data.bins [emoji…], data.items [{e, bin}], text.bins, text.words:
                 картинка → в какой «домик» (звук) она относится;
         where — data.items [{pos 0|1|2}], text.words: где звук — в начале,
                 в середине, в конце;
         clap  — data.items [{has bool}], text.words: есть ли звук в слове.
       data.rounds — сколько раундов (по умолчанию 8). */
    function shuffle(a) {
        a = a.slice();
        for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = a[i]; a[i] = a[j]; a[j] = x; }
        return a;
    }
    K.step('phoneme-game', {
        reviewable: false,
        mount: function (host, step, api) {
            var t = T(step);
            var mode = step.mode || 'pair';
            if (t.title) host.appendChild(api.el('h3', null, t.title));
            if (t.prompt) host.appendChild(api.richEl('p', 'crs-prompt', t.prompt));
            lines(host, api, t.how);
            var deck = [];
            if (mode === 'pair') {
                (step.pairs || []).forEach(function (pe, i) {
                    var w = (t.pairs || [])[i] || [];
                    deck.push({ say: w[0], ok: 0, cards: [{ e: pe[0], w: w[0] }, { e: pe[1], w: w[1] }] });
                    deck.push({ say: w[1], ok: 1, cards: [{ e: pe[0], w: w[0] }, { e: pe[1], w: w[1] }] });
                });
            } else if (mode === 'sort') {
                (step.items || []).forEach(function (it, i) {
                    deck.push({ say: (t.words || [])[i], pic: it.e, ok: it.bin });
                });
            } else if (mode === 'where') {
                (step.items || []).forEach(function (it, i) { deck.push({ say: (t.words || [])[i], ok: it.pos }); });
            } else {
                (step.items || []).forEach(function (it, i) { deck.push({ say: (t.words || [])[i], ok: it.has ? 0 : 1 }); });
            }
            deck = shuffle(deck).slice(0, step.rounds || 8);
            var stage = api.el('div', 'ssc-game');
            host.appendChild(stage);
            var i = 0, right = 0, misses = [];
            function round() {
                stage.innerHTML = '';
                if (i >= deck.length) { end(); return; }
                var d = deck[i];
                var adult = api.el('p', 'ssc-adult');
                adult.appendChild(api.el('span', 'ssc-adult-k', api.tt('ss_adult_says')));
                adult.appendChild(api.el('b', null, '«' + (d.say || '') + '»'));
                stage.appendChild(adult);
                stage.appendChild(api.el('p', 'crs-hint', api.tt('ss_round', { n: i + 1, total: deck.length })));
                if (mode === 'sort' && d.pic) stage.appendChild(api.el('div', 'ssc-pic', d.pic));
                var row = api.el('div', 'ssc-cards');
                var opts;
                if (mode === 'pair') opts = d.cards.map(function (c) { return { big: c.e, small: c.w }; });
                else if (mode === 'sort') opts = (step.bins || []).map(function (e, k) { return { big: e, small: (t.bins || [])[k] || '' }; });
                else if (mode === 'where') opts = [0, 1, 2].map(function (k) { return { big: ['🚂', '🚃', '🚃'][k], small: api.tt('ss_where_' + k) }; });
                else opts = [{ big: '👏', small: api.tt('ss_clap_yes') }, { big: '🤫', small: api.tt('ss_clap_no') }];
                opts.forEach(function (o, k) {
                    var b = api.el('button', 'ssc-card');
                    b.type = 'button';
                    b.appendChild(api.el('span', 'ssc-card-big', o.big));
                    if (o.small) b.appendChild(api.el('span', 'ssc-card-small', o.small));
                    b.setAttribute('aria-label', o.small || o.big);
                    b.addEventListener('click', function () { pick(k, b); });
                    row.appendChild(b);
                });
                if (mode === 'where') row.classList.add('ssc-cards-3');
                stage.appendChild(row);
            }
            var lock = false;
            function pick(k, b) {
                if (lock) return;
                lock = true;
                var d = deck[i];
                var ok = k === d.ok;
                if (ok) right++; else misses.push(d.say);
                b.classList.add(ok ? 'is-right' : 'is-wrong');
                api.announce(ok ? api.tt('ss_game_right') : api.tt('ss_game_wrong'));
                setTimeout(function () { if (!api.alive()) return; lock = false; i++; round(); }, ok ? 650 : 1300);
            }
            function end() {
                var share = deck.length ? right / deck.length : 0;
                var out = [api.tt('ss_game_score', { n: right, total: deck.length })];
                out.push(share >= 0.8 ? api.tt('ss_game_good') : share >= 0.5 ? api.tt('ss_game_mid') : api.tt('ss_game_low'));
                if (misses.length) out.push(api.tt('ss_game_misses', { list: misses.map(function (w) { return '«' + w + '»'; }).join(', ') }));
                api.answer({ correct: null, explain: out.join('\n') + (t.explain ? '\n\n' + t.explain : '') });
            }
            api.primary(api.tt('ss_game_start'), function () { api.primary(null, null); round(); });
            api.onKey(function (key) {
                var n = parseInt(key, 10);
                var btns = stage.querySelectorAll('.ssc-card');
                if (n >= 1 && n <= btns.length) { btns[n - 1].click(); return true; }
                return false;
            });
        }
    });

    window.SpeechSoundsCourse = { pct: pct };
})();
